
import {$http} from "../service/service.js";
let http = {}
let $user = {
	login: (data) => {
		http.url = 'api/auth/login';
		http.data = data;
		http.method = 'post';
		return $http.post(http);
	}
}

export default $user;



// WEBPACK FOOTER //
// ./src/api/user.js